import { useUserProductsKiosk } from "~/api/products/hooks/use-user-products";
import { type ApiErrorResponse } from "~/api/error";
import { DisplayErrorMessage } from "~/components/display-error-message";

import { ModalError } from "../error/modal-error";
import { ModalLoadingGeneric } from "../loading/modal-loading-generic";

import {
  ModalOrderMinimum,
  type ModalOrderMinimumProduct
} from "./modal-order-minimum";

type KioskProduct = { id: string; name: string; orderMin: number | null };

export const toOrderMinimumProducts = (
  productIds: string[],
  products: KioskProduct[]
): ModalOrderMinimumProduct[] => {
  const byId = new Map(products.map((product) => [product.id, product]));

  return productIds.flatMap((id) => {
    const product = byId.get(id);
    const orderMin = product?.orderMin ?? null;
    if (!product || orderMin === null) return [];

    return [{ id, name: product.name, orderMin }];
  });
};

type ModalOrderMinimumContainerProps = {
  error: ApiErrorResponse;
  onBack: () => void;
  paymentReversed?: boolean;
};

export const ModalOrderMinimumContainer = ({
  error,
  onBack,
  paymentReversed
}: ModalOrderMinimumContainerProps) => {
  const { data, isLoading } = useUserProductsKiosk();

  if (isLoading) {
    return <ModalLoadingGeneric />;
  }

  const products = toOrderMinimumProducts(
    error.body.productIds ?? [],
    data?.products ?? []
  );

  if (products.length === 0) {
    return (
      <ModalError onClose={onBack}>
        <DisplayErrorMessage error={error} />
      </ModalError>
    );
  }

  return (
    <ModalOrderMinimum
      products={products}
      onUpdateOrder={onBack}
      paymentReversed={paymentReversed}
    />
  );
};
